import _ from 'lodash';
import { orgId, contactIdPrivate } from 'utils';


export default ({
  values: {
    firstName,
    lastName,
    username,
    password,
    securityQuestion,
    securityAnswer,
    email,
    mobilePhone,
    mobilePhoneCountryCode,
    smsPhone,
    smsPhoneCountryCode,
    locationName,
    street,
    suite,
    city,
    postalCode,
    state,
    country,
    id,
    lon,
    lat,
    slack
  },
  setSubmitting,
  emailSetting,
  phoneSetting,
  SMSSetting,
  addressGeoCodingSource,
  createAccount,
  SmsValidate,
  PhoneValidate,
  pristineLocationName,
  emailQuietTimeFrame,
  phoneQuietTimeFrame,
  smsQuietTimeFrame, slackSetting, slackQuietTimeFrame
}) => {
  const contactPaths = [];
  if (!_.isEmpty(phoneSetting) && phoneSetting.exposed) {
    contactPaths.push({
      pathId: phoneSetting.pathId,
      type: phoneSetting.type,
      countryCode: mobilePhoneCountryCode,
      value: mobilePhone,
      noValidate: PhoneValidate || phoneSetting.noValidate,
      quietTimeFrames: phoneQuietTimeFrame
    });
  }
  if (!_.isEmpty(SMSSetting) && SMSSetting.exposed) {
    contactPaths.push({
      pathId: SMSSetting.pathId,
      type: SMSSetting.type,
      countryCode: smsPhoneCountryCode,
      value: smsPhone,
      noValidate: SmsValidate || SMSSetting.noValidate,
      quietTimeFrames: smsQuietTimeFrame
    });
  }
  console.log(`ContactIDPrivate ${contactIdPrivate}`);
  if (contactIdPrivate && !_.isEmpty(emailSetting) && emailSetting.exposed && email) {
    contactPaths.push({
      pathId: emailSetting.pathId,
      type: emailSetting.type,
      countryCode: null,
      value: email,
      noValidate: emailSetting.noValidate,
      quietTimeFrames: emailQuietTimeFrame,
    });
  }
  //Slack path
  if (!_.isEmpty(slackSetting) && slack) {
    contactPaths.push({
      pathId: 241901148045405,
      type: "SLACK",
      countryCode: null,
      value: slack,
      noValidate: slackSetting.noValidate,
      quietTimeFrames: slackQuietTimeFrame,
    });
  }

  const contactAddress = !locationName || !street
    ? {}
    : {
      contactAddressVo: {
        pristineLocationName,
        locationName,
        country,
        streetAddress: street,
        suite,
        city,
        state,
        postalCode,
        lon,
        lat,
        addressGeoCodingSource,
        id,
        slack
      },
    };
  createAccount(
    {
      firstName,
      lastName,
      username,
      password,
      securityQuestion,
      securityAnswer,
      organizationId: orgId,
      email,
      contactPaths,
      ...contactAddress,
    },
    () => setSubmitting(false),
  );
};
